import React from 'react';
import { Button, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { faPrint } from '@fortawesome/pro-light-svg-icons/faPrint';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { bindActionCreators } from 'redux';
import { faArrowToBottom } from '@fortawesome/pro-light-svg-icons';
import { Box } from '../../shared/components';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import { descargarInforme } from '../../../state/actions/creators/informes.actioncreator';
import ActionsHeader, { NAVIGATION_ANCHOR } from '../../shared/containers/ActionsHeader';

class BarraSuperiorAccionesEncargo extends React.Component {
  onImprimir() {
    const { descargarInforme, encargoId, tiendaId } = this.props;
    descargarInforme({ informeId: 10, plantillaId: 4, parametros: { venta_id: encargoId, tienda_id: tiendaId } });
  }

  render() {
    const { onDevolver } = this.props;

    const botonDevolucionDeshabilitado = true;

    const data = [
      {
        translationId: 'encargos.devolver',
        text: 'Generar pedido',
        onClick: () => {},
        disabled: botonDevolucionDeshabilitado,
        visible: false,
      },
      {
        translationId: 'encargos.facturar',
        text: 'Comprobar stock',
        onClick: () => {},
        disabled: true,
        visible: false,
      },
      {
        translationId: 'encargos.retirar',
        text: 'Comprobar stock',
        onClick: () => {},
        disabled: true,
        visible: false,
      },
      {
        translationId: 'encargos.pedir',
        text: 'Comprobar stock',
        onClick: () => {},
        disabled: true,
        visible: false,
      },
      {
        translationId: 'encargos.tramitar',
        text: 'Comprobar stock',
        onClick: () => {},
        disabled: true,
        visible: false,
      },
      { icon: faPrint, position: 'right', onClick: () => this.onImprimir() },
      { icon: faEllipsisH, position: 'right', onClick: () => {} },
    ];
    return <ActionsHeader anchor={NAVIGATION_ANCHOR} sticky data={data} />;

    return (
      <Box border="1px solid #DADCE0" p="8">
        <TwoColumnsFlexLayout
          leftContent={(
            <Box>
              <Box display="inline-block" borderRight="1px solid #DADCE0" my="4" px="4">
                <Button
                  size="small"
                  disabled={botonDevolucionDeshabilitado}
                  type="link"
                  onClick={() => onDevolver()}
                >
                  Devolver
                </Button>
              </Box>
              { this.placeholderButton('Facturar') }
              { this.placeholderButton('Retirar') }
              { this.placeholderButton('Pedir') }
              { this.placeholderButton('Tramitar') }
            </Box>
          )}
          rightContent={(
            <Box>
              <Box style={{ float: 'right' }}>
                <Button type="link" size="small" onClick={() => this.onImprimir()}>
                  <FontAwesomeIcon icon={faPrint} />
                </Button>
                { this.placeholderButton(<FontAwesomeIcon icon={faEllipsisH} />, 'last') }
              </Box>
            </Box>
          )}
        />
      </Box>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    descargarInforme,
  }, dispatch);
}

const mapStateToProps = state => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BarraSuperiorAccionesEncargo);

BarraSuperiorAccionesEncargo.propTypes = {
  descargarInforme: PropTypes.func.isRequired,
  encargoId: PropTypes.number.isRequired,
  onDevolver: PropTypes.func.isRequired,
  tiendaId: PropTypes.number.isRequired,
};
